import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';

import {DocToc, PageHero, PageShell, PageTitle, Prose, Section} from 'components';

import EnContent from './content/en';
import KoContent from './content/ko';
import RuContent from './content/ru';
import ZhContent from './content/zh';

/**
 * 代理合作机制（i18n 壳）：正文迁移自老文档站 /doc/proxyMechanism/（代理返点机制 + 如何成为代理），
 * 按语言选择 content/zh|en|ko|ru 内容组件（ko/ru 为 2026-09-17 AI 翻译）。
 * v3 改版：PageHero(soft) 头部 + Prose 文档排版
 * （语义标签，样式见 styles/v3/prose.css），不再复用 ApiDoc.scss。
 * 入口：导航「商务合作 → 代理返现」。
 */
const ProxyMechanism: FC = () => {
  const {i18n, t} = useTranslation('docs');
  const contentByLang: Record<string, FC> = {en: EnContent, ko: KoContent, ru: RuContent};
  const Content = contentByLang[i18n.language] ?? ZhContent;

  return (
    <PageShell>
      <PageTitle canonicalUrl="https://www.xiangjifanyi.com/home/proxy-mechanism" title={t('proxyMechanism.title')} />
      <PageHero
        badge={t('proxyMechanism.heroBadge')}
        description={t('proxyMechanism.heroDescription')}
        title={t('proxyMechanism.title')}
        variant="soft"
      />
      <Section compact>
        <div className="max-w-[79rem] mx-auto xl:grid xl:grid-cols-[12.5rem_minmax(0,48rem)_12.5rem] xl:gap-12">
          {/* 左占位列：与目录等宽，正文保持页面正中（目录仅 xl+ 显示） */}
          <div aria-hidden="true" className="hidden xl:block" />
          <Prose>
            <Content />
          </Prose>
          <DocToc className="hidden xl:block" />
        </div>
      </Section>
    </PageShell>
  );
};

export default ProxyMechanism;
